import { checkForValidAlgoliaParameters } from '~/helpers/algolia/algoliaParameters';
import searchParameterRedirection from '~/helpers/routes/searchParameterRedirection';

export default ({ app: { context: { route } }, redirect }) => {
  checkForValidAlgoliaParameters(route.query, searchParameterRedirection(route, redirect));
};
